import { Link } from 'react-router-dom'
import 'primeicons/primeicons.css'

export default function HeroContent() {
  return (
    <div className="max-w-5xl mx-auto">
      {/* Main Headlines - Centered */}
      <div className="mb-8 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight text-white">
          Huấn luyện bóng đá thực chiến
        </h1>
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
          <span className="text-gold-400">Nâng cấp kỹ năng từng ngày</span>
        </h2>
      </div>

      {/* Sub-text - Centered */}
      <p className="text-base md:text-lg text-white mb-10 leading-relaxed max-w-2xl mx-auto text-center">
        Tập luyện hiệu quả – Cảm nhận sự tiến bộ sau mỗi buổi
      </p>

      {/* CTA Buttons - Centered */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <Link
          to="/course/online"
          className="px-8 py-4 bg-gold-gradient text-white/80 font-bold text-base md:text-lg rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition transform hover:scale-105 flex items-center justify-center gap-2 w-full sm:w-auto min-w-[200px]"
        >
          <i className="pi pi-book text-lg"></i>
          <span>Xem khóa học</span>
        </Link>
        <Link
          to="/classes"
          className="px-8 py-4 border-2 border-gold-500 text-white font-bold text-base md:text-lg rounded-lg hover:bg-gold-500/10 transition transform hover:scale-105 flex items-center justify-center gap-2 w-full sm:w-auto min-w-[200px]"
        >
          <i className="pi pi-user-plus text-lg"></i>
          <span>Đăng ký tập thử</span>
        </Link>
      </div>
    </div>
  )
}

